import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useReviewsQueryParams } from '~/scopes/reviews/reviews-display/composables/useReviewsQueryParams'
import { transformReviewsResponse } from '~/scopes/reviews/reviews-display/utils/transformReviewsResponse'

export function useProductListReviews(id: string) {
  const $httpFetch = useHttpFetch()
  const queryParams = useReviewsQueryParams()

  return useAsyncData(
    computed(() =>
      getAsyncDataKey('product-reviews', { id, ...queryParams.value }),
    ),
    () =>
      $httpFetch('/reviews/v1/product-landings/:uuid/products/reviews', {
        pathParams: { uuid: id },
        query: queryParams.value,
      }),
    {
      transform: (response) => ({
        previousCursor: response.previousCursor,
        nextCursor: response.nextCursor,
        results: transformReviewsResponse(response.results),
      }),
    },
  )
}
